var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { captureException } from '@sentry/react';
import { getNotificationsFailed, getNotificationsRequested, getNotificationsSucceeded, getMessageThreadFailed, getMessageThreadRequested, getMessageThreadSuceeded, getMessagesFailed, getMessagesRequested, getMessagesSucceeded, replyToThreadFailed, replyToThreadRequested, replyToThreadSucceeded, markMessageAsReadRequested, markMessageAsReadSucceeded, markNotificationsAsReadRequested, } from './messageThreadSlice';
import tryUploadFiles from '../../../utils/fileUpload';
function markMessageAsRead(action) {
    var e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, call(axios.patch, "/customer/messages/threads/".concat(action.payload.threadId, "/messages/read"), {
                        ids: action.payload.messageIds,
                    })];
            case 1:
                _a.sent();
                return [4 /*yield*/, put(markMessageAsReadSucceeded({
                        threadId: action.payload.threadId,
                        messageIds: action.payload.messageIds,
                    }))];
            case 2:
                _a.sent();
                return [3 /*break*/, 4];
            case 3:
                e_1 = _a.sent();
                captureException(e_1);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}
function getNotifications() {
    var res, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, call(axios.get, '/customer/notifications')];
            case 1:
                res = _a.sent();
                return [4 /*yield*/, put(getNotificationsSucceeded(res.data))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                e_2 = _a.sent();
                return [4 /*yield*/, put(getNotificationsFailed(e_2))];
            case 4:
                _a.sent();
                captureException(e_2);
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function markNotificationAsRead(action) {
    var e_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, call(axios.patch, "/customer/notifications/".concat(action.payload, "/read"))];
            case 1:
                _a.sent();
                return [3 /*break*/, 3];
            case 2:
                e_3 = _a.sent();
                captureException(e_3);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}
function getMessages(action) {
    var response, e_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, call(axios.get, "/customer/messages/threads/".concat(action.payload.threadId, "/messages"))];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, put(getMessagesSucceeded(response.data))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                e_4 = _a.sent();
                return [4 /*yield*/, put(getMessagesFailed(e_4))];
            case 4:
                _a.sent();
                captureException(e_4);
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function getMessageThread(action) {
    var response, e_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, call(axios.get, "/customer/messages/threads/".concat(action.payload.threadId))];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, put(getMessageThreadSuceeded(response.data))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                e_5 = _a.sent();
                return [4 /*yield*/, put(getMessageThreadFailed(e_5))];
            case 4:
                _a.sent();
                captureException(e_5);
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function replyToThread(action) {
    var _a, threadId, body, files, fileUploadResponses, response, newMessage, e_6;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 4, , 6]);
                _a = action.payload, threadId = _a.threadId, body = _a.body, files = _a.files;
                return [4 /*yield*/, call(tryUploadFiles, files)];
            case 1:
                fileUploadResponses = _b.sent();
                return [4 /*yield*/, call(axios.post, "/customer/messages/threads/".concat(threadId, "/messages"), {
                        body: body,
                        files: fileUploadResponses,
                    })];
            case 2:
                response = _b.sent();
                newMessage = {
                    id: response.data.messageId,
                    body: body,
                    createdDate: new Date().toISOString(),
                    type: 'Inbound',
                    isRead: true,
                    isFromAdvisor: false,
                    files: fileUploadResponses,
                };
                return [4 /*yield*/, put(replyToThreadSucceeded(newMessage))];
            case 3:
                _b.sent();
                return [3 /*break*/, 6];
            case 4:
                e_6 = _b.sent();
                return [4 /*yield*/, put(replyToThreadFailed(e_6))];
            case 5:
                _b.sent();
                captureException(e_6);
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function chatSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeLatest(replyToThreadRequested.type, replyToThread),
                    takeLatest(getMessageThreadRequested.type, getMessageThread),
                    takeLatest(getMessagesRequested.type, getMessages),
                    takeLatest(markMessageAsReadRequested.type, markMessageAsRead),
                    takeLatest(getNotificationsRequested.type, getNotifications),
                    takeLatest(markNotificationsAsReadRequested.type, markNotificationAsRead),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default chatSaga;
